import { Component, OnInit } from '@angular/core';
import { Breadcrumb } from '@shared/components';
import { AuthService } from '@core/auth';
import { NgBsToastService } from 'ng-bs-toast-service';
import { HttpErrorResponse } from '@angular/common/http';
import { User } from '@shared/models';
import { DoctorsService } from '../doctors.service';
import { Doctor } from '../doctors.model';

@Component({
    selector: 'app-profile',
    standalone: false,
    templateUrl: './profile.component.html',
})
export class ProfileComponent implements OnInit {
    loading = { main: false, save: false };
    doctor = {} as Doctor;
    password = { new: undefined, confirm: undefined };

    breadcrumb: Breadcrumb[] = [
        // { title: 'Inicio', route: ['/'] },
        { title: 'Perfil' },
    ];

    constructor(
        private authService: AuthService,
        private doctorsService: DoctorsService,
        private toastService: NgBsToastService
    ) {}

    ngOnInit() {
        this.getProfile();
    }

    getProfile() {
        this.loading.main = true;
        this.doctorsService
            .getById(this.authService.user.sub)
            .subscribe({
                next: (res) => (this.doctor = res),
                error: (err: HttpErrorResponse) =>
                    this.toastService.send(
                        `Error ${err.status}`,
                        err.error.error || err.name,
                        'danger'
                    ),
            })
            .add(() => (this.loading.main = false));
    }

    validateProfileForm() {
        return !this.doctor.name || !this.doctor.email || this.loading.save;
    }

    saveProfile() {
        this.loading.save = true;
        this.doctorsService
            .update(this.doctor)
            .subscribe({
                next: () => {
                    this.getProfile();
                    this.authService.user = {
                        ...this.authService.user,
                        ...this.doctor,
                    } as User;
                    this.toastService.send(
                        'Sucesso',
                        'Perfil alterado com sucesso!',
                        'success'
                    );
                },
                error: (err: HttpErrorResponse) =>
                    this.toastService.send(
                        `Error ${err.status}`,
                        err.error.error || err.name,
                        'danger'
                    ),
            })
            .add(() => (this.loading.save = false));
    }

    checkPassword() {
        return (
            this.password.new &&
            this.password.confirm &&
            this.password.new !== this.password.confirm
        );
    }

    validatePasswordForm() {
        return (
            !this.password.new || !this.password.confirm || this.loading.save
        );
    }

    updatePassword() {
        this.loading.save = true;
        this.doctorsService
            .changePassword(this.doctor.id, this.password.new!)
            .subscribe({
                next: () => {
                    this.password = { new: undefined, confirm: undefined };
                    this.toastService.send(
                        'Sucesso',
                        'Senha alterada com sucesso!',
                        'success'
                    );
                },
                error: (err: HttpErrorResponse) =>
                    this.toastService.send(
                        `Error ${err.status}`,
                        err.error.error || err.name,
                        'danger'
                    ),
            })
            .add(() => (this.loading.save = false));
    }
}
